import { render, staticRenderFns } from "./StatDialog.vue?vue&type=template&id=b9d655cc&"
import script from "./StatDialog.vue?vue&type=script&lang=js&"
export * from "./StatDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports